import React from 'react';

import BlockContent from './BlockContent';

export default function TextSections({ section }) {
  const { references } = section;
  const style = `text-sections --${references?.length}`;
  return (
    <>
      {references && (
        <div className={style}>
          {references.map((r) => (
            <BlockContent key={r.id} content={r.blockContent} />
          ))}
        </div>
      )}
    </>
  );
}
